import axios from 'axios';

const TOKEN_KEY = 'access_token';

/** Persist access token for Authorization header when cookies are blocked cross-origin. */
export function setAccessToken(token) {
  if (token) sessionStorage.setItem(TOKEN_KEY, token);
  else sessionStorage.removeItem(TOKEN_KEY);
}

export function getAccessToken() {
  return sessionStorage.getItem(TOKEN_KEY) || '';
}

export function clearAccessToken() {
  sessionStorage.removeItem(TOKEN_KEY);
}

// Always send cookies; also attach Bearer token when available
axios.defaults.withCredentials = true;

axios.interceptors.request.use((config) => {
  const token = getAccessToken();
  if (token) {
    config.headers = config.headers || {};
    if (!config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});
